module.exports = __webpack_public_path__ + "img/Transparant@3x.0d25c540.png";